/**
 *
 * Inline Style (JS)
 *
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2023-05-12
 *
 */


window.ST = window['ST'] || {};


(function (NS) {

	const SEL_TARGET = '.stile';


	NS.addInit(1, () => {
		const spans = document.querySelectorAll(SEL_TARGET + ' span');
		modifySpanStyle(spans);
		const fs = document.querySelectorAll(SEL_TARGET + ' iframe');
		modifyIframeStyle(fs);
	});


	// Span Styles -------------------------------------------------------------


	function modifySpanStyle(spans) {
		for (let i = 0; i < spans.length; i += 1) {
			const target = spans[i];
			let type = target.style.textDecorationLine;
			if (type === undefined) {  // for IE11, Edge
				type = target.style.textDecoration;
				if (type === 'underline') {
					target.style.textDecoration = '';
					NS.addStile(target, 'inline-' + type);
				}
			} else {
				if (type === 'underline') {
					target.style.textDecorationLine = '';
					NS.addStile(target, 'inline-' + type);
				}
			}
		}
	}


	// Iframe Styles -----------------------------------------------------------


	function modifyIframeStyle(fs) {
		observe(fs, f => {
			const size = extractIframeSize(f);
			if (size) addIframeWrapper(f, size[0], size[1]);
		});
		for (let i = 0; i < fs.length; i += 1) {
			const f = fs[i];
			const size = extractIframeSize(f);
			if (size) addIframeWrapper(f, size[0], size[1]);
		}
	}

	function extractIframeSize(f) {
		let w = parseInt(f.width);
		let h = parseInt(f.height);
		if (w && h) return [w, h];

		const sW = f.style.width;
		const sH = f.style.height;
		if (sW.indexOf('px') !== sW.length - 2) return null;
		if (sH.indexOf('px') !== sH.length - 2) return null;
		w = parseInt(sW);
		h = parseInt(sH);
		if (w && h) return [w, h];
		return null;
	}

	function addIframeWrapper(f, w, h) {
		let wrap   = null;
		let spacer = null;
		if (f.parentElement.dataset['stile'] === 'iframe-wrapper') {
			wrap   = f.parentElement;
			spacer = wrap.querySelector(':scope > div');
		} else {
			wrap = document.createElement('SPAN');
			NS.addStile(wrap, 'iframe-wrapper');
			spacer = document.createElement('DIV');
			wrap.appendChild(spacer);
			f.parentElement.insertBefore(wrap, f);
			wrap.appendChild(f);
		}
		spacer.style.paddingTop = (100 * h / w) + '%';
		wrap.style.maxWidth = w + 'px';
		wrap.dataset['aspect'] = Math.round(w / h * 1000) / 1000;
	}

	function observe(fs, fn) {
		if (!fs.length) return;
		const mo = new MutationObserver(() => { for (const f of fs) fn(f); });
		for (const f of fs) mo.observe(f, { attributes: true });
	}

})(window.ST);
